enum CaseStyle {
  Camel = 'camel',
  Snake = 'snake',
}

export default CaseStyle;
